import Lore from './lore';
export default Lore;